import React, { Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

//MUI
import MuiLink from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

//Icons
import LocationOn from "@material-ui/icons/LocationOn";
import LinkIcon from "@material-ui/icons/Link";
import CalendarToday from "@material-ui/icons/CalendarToday";
// import { ThemeProvider } from "@material-ui/core";

const styles = {
  paper: {
    padding: "20px",
    marginTop: "40px",
  },
  buttons: { padding: "10px" },
  profile: {
    "& .image-wrapper": {
      testAlign: "center",
      position: "relative",
      "& button": {
        position: "absolute",
        top: "80%",
        left: "70%",
      },
    },
    "& .profile-image": {
      width: 200,
      height: 200,
      objectFit: "cover",
      maxWidth: "100%",
      borderRadius: "50%",
    },
    "& .profile-details": {
      textAlign: "center",
      "& span, svg": {
        verticalAlign: "middle",
      },
      "& a": {
        color: "primary",
      },
    },
    "& hr": {
      border: "none",
      margin: "0 0 10px 0",
    },
  },
};

const StaticProfile = (props) => {
  const {
    classes,
    profile: {
      handle,
      createdAt,
      imageUrl,
      bio,
      website,
      location,
      firstName,
      lastName,
      collegeName,
      streamName,
    },
  } = props;

  return (
    <Paper className={classes.paper}>
      <div className={classes.profile}>
        <div className="image-wrapper">
          <Grid container justify="center">
            <img src={imageUrl} alt="profile" className="profile-image" />
          </Grid>
        </div>
        <hr />
        <div className="profile-details">
          <MuiLink
            component={Link}
            to={`/users/${handle}`}
            color="secondary"
            variant="h5"
          >
            @{handle}
          </MuiLink>
          <hr />
          {bio && (
            <Fragment>
              <Typography variant="body2">Bio: {bio}</Typography>
              <hr />
            </Fragment>
          )}
          {collegeName && (
            <Fragment>
              <Typography variant="body1">College: {collegeName}</Typography>
              {/* <hr /> */}
            </Fragment>
          )}
          {firstName && (
            <Fragment>
              <Typography variant="body1">
                Name: {firstName} {lastName}
              </Typography>
              {/* <hr /> */}
            </Fragment>
          )}
          {streamName && (
            <Fragment>
              <Typography variant="body1">Stream: {streamName}</Typography>
              <hr />
            </Fragment>
          )}
          {location && (
            <Fragment>
              <LocationOn color="secondary" /> <span>{location}</span>
              <hr />
            </Fragment>
          )}
          {website && (
            <Fragment>
              <LinkIcon color="primary" />
              <a href={website} target="_blank" rel="noopener noreferrer">
                {" "}
                {website}
              </a>
              <hr />
            </Fragment>
          )}
          <CalendarToday color="secondary" />{" "}
          <span>Joined At: {dayjs(createdAt).format("MMM YYYY")}</span>
        </div>
      </div>
    </Paper>
  );
};

StaticProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StaticProfile);
